import { render, staticRenderFns } from "./SidebarSupportWidget.vue?vue&type=template&id=f09d082e&scoped=true"
import script from "./SidebarSupportWidget.vue?vue&type=script&lang=js"
export * from "./SidebarSupportWidget.vue?vue&type=script&lang=js"
import style0 from "./SidebarSupportWidget.vue?vue&type=style&index=0&id=f09d082e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09d082e",
  null
  
)

export default component.exports